import { Component, OnInit } from '@angular/core'
import { RequestsService } from 'src/app/_shared/services/requests.service'
import { AuthenticationService } from '../../../_services/authentication.service'

declare var jQuery: any

@Component({
  selector: 'app-cropinfo-headings',
  templateUrl: './cropinfo-headings.component.html',
  styleUrls: ['./cropinfo-headings.component.scss'],
})
export class CropinfoHeadingsComponent implements OnInit {
  constructor(
    private requestService: RequestsService,
    private authenticationService: AuthenticationService
  ) {}

  model: any = {}
  loading: boolean
  deleteHeadingloading: boolean
  diagnosisViewData: object
  deleteHeadingSuccess: boolean
  createHeadingisSuccess: boolean
  editHeadingisSuccess: boolean
  editError: boolean
  showFilter = true
  page = 1
  count = 10
  data: []
  message: string
  category: string
  diagnosisId: string
  diagnosisData: object
  headingDeleteData: object
  diagnosisAction: string
  modalId: string
  editHeadingInfoData: object
  submitted = false
  crops: any
  country_id: string
  country_name: string
  selectedCrops: any
  searchItem: string
  selectCrop = []
  selectDisease = []
  selectedName: any
  namesToSelect = []
  explanationTitle: string
  parts: any

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country_id, country } = currentUser
    this.country_id = country_id
    this.country_name = country
    this.loadAgronomicalHeaders()
  }

  loadAgronomicalHeaders(): void {
    this.loading = true
    this.requestService
      .dash_get(`dashboard/agronomical-info-heading/${this.country_name}`, null)
      .subscribe(
        (res) => {
          this.loading = false
          this.data = res.data
          let crops = []
          let names = []
          res.data
            ? res.data.map((each) => {
                names.push({ label: each.name, value: each.name })
              })
            : null
          this.namesToSelect = names
        },
        (err) => {
          this.loading = false
          this.message = err.error
        }
      )
  }

  handleSubmit(createDiagnosisForm) {
    this.submitted = true
    const formData = new FormData()
    formData.append('name', createDiagnosisForm.name)
    this.postAgronomicalHeaders(formData)
  }

  postAgronomicalHeaders(data: object) {
    this.loading = true
    this.requestService
      .dash_putWithImage(
        `dashboard/agronomical-info-heading/${this.country_name}`,
        data
      )
      .subscribe(
        (res) => {
          this.loading = false
          this.message = res.message
          this.createHeadingisSuccess = res.success
          // form.reset();
          this.loadAgronomicalHeaders()
        },
        (err) => {
          const { error } = err
          this.loading = false
          this.message = error.error
        }
      )
  }

  resetModal() {
    // this.modal.hide();
    jQuery('#diagnosisForm').trigger('reset')
    // jQuery('#agroModal').modal('hide');
    this.createHeadingisSuccess = false
    // this.serverError = false;
  }

  setHeadingAction(data: object) {
    this.editHeadingInfoData = data
  }

  handleEdit(updateInputForm, id) {
    this.loading = true
    const form = updateInputForm
    const URL = `agronomical-info-heading/${id}`
    let formData = new FormData()

    formData.append('name', form.name)

    this.requestService.dash_putWithImage(URL, formData).subscribe(
      (response) => {
        this.submitted = true
        this.loading = true
        if (response.success) {
          this.editHeadingisSuccess = true
          this.loadAgronomicalHeaders()
        } else if (!response.success) {
          this.loading = false
          this.message = response.message
          this.editError = true
        }

        // this.message = response.message;
        // this.successModal = true;
        // this.reloadInputs();
      },
      (error) => {
        this.loading = false
        this.message = 'Some error occurred. Please try again'
        this.editError = true
      }
    )
  }

  resetEditModal() {
    // this.modal.hide();
    jQuery('#editSmartModal').modal('hide')
    this.editHeadingisSuccess = false
    this.editError = false
  }

  deleteInfoDetails(data: object) {
    this.headingDeleteData = data
  }

  deleteHeading(id: string): void {
    this.deleteHeadingloading = true
    this.requestService.dash_delete(id, `agronomical-info-heading`).subscribe(
      (res) => {
        this.deleteHeadingloading = false
        this.deleteHeadingSuccess = true
        this.loadAgronomicalHeaders()
        this.message = 'Heading information deleted successfully'
      },
      (err) => {
        this.deleteHeadingloading = false
        this.deleteHeadingSuccess = false
        if (err.status === 404) {
          this.message = 'Heading information not found!'
        } else {
          this.message = 'Some error occurred. Please try again'
        }
      }
    )
  }

  resetDeleteModal() {
    // this.modal.hide();
    jQuery('#deleteModal').modal('hide')
    this.deleteHeadingSuccess = false
    this.message = ''
  }
}
